/*global chrome*/
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import Header from "./Header";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Frame1 from "../../assets/images/public-pages/Frame1.svg";
import Frame2 from "../../assets/images/public-pages/Frame2.svg";
import Frame3 from "../../assets/images/public-pages/Frame3.svg";
import Frame4 from "../../assets/images/public-pages/Frame4.svg";
import Frame5 from "../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../assets/images/public-pages/Frame19.svg";
import Frame20 from "../../assets/images/public-pages/Frame11.svg";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import ScoreInfoCard from "components/PublicPagesReusable/ScoreInfoCard";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import ExamSkillsSection from "components/PublicPagesReusable/ExamSkillsSection";
import Globe from "assets/images/public-pages/green-globe.svg"
import Growth from "assets/images/public-pages/green-growth.svg"
import Idea from "assets/images/public-pages/green-idea-2.svg"
import Collab from "assets/images/public-pages/green-collab.svg"
import WorkBalance from "assets/images/public-pages/green-balance.svg"
import Work from "assets/images/public-pages/green-work.svg"
import Filter from "../../assets/images/public-pages/filter.svg";
import checkList from "../../assets/images/public-pages/check-list.svg";
import TestEnvironmentIcon from "../../assets/images/public-pages/TestEnvironmentIcon.png";
import flexibleIcon from "../../assets/images/public-pages/flexible-icon.svg";
import ReactHtmlParser from "react-html-parser";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import Complement from "../../assets/images/public-pages/complement.svg";
import Essential from "../../assets/images/public-pages/essential.svg";
import Professional from "../../assets/images/public-pages/professional.svg";
import Commuters from "../../assets/images/public-pages/commuters.svg";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import Immigration from "../../assets/images/public-pages/victoria-take-test.png";

const AIScoreSeo = React.memo(() => {
    const heroWorkTitle = () => {
        return (
            <h1 className="FS48 fw-500 top-section-text text-center">
                <span className="fw-600 text-success">AI Scoring in PTE: </span>
                How Artificial Intelligence and
                <br /> Human Experts Evaluates Your Test
            </h1>
        );
    };

    const heroData = {
        badge: "Australia’s Leading English Proficiency Centre",
        title: heroWorkTitle,
        subtitle:
            "Discover how PTE uses advanced AI algorithms combined with human expert review to deliver fast, accurate, and fair scoring across Speaking, Writing, Reading, and Listening.",
        bottomStatsText: [
            { value: "50,000", highlight: "+", label: "Successful Students" },
            { value: "95", highlight: "%", label: "AI Scoring Accuracy" },
            { value: "29,000", highlight: "+", label: "Practiced Questions" },
        ],
        btnText: "Try AI-Scored Mock Test",
        btnLink: "/auth/register",
        btn_outline: {
            text: "Learn More",
            variant: "outline",
            link: "/auth/register",
        },
    };

    const images = [
        { src: Frame1, alt: "pte-score-1" },
        { src: Frame2, alt: "pte-score-2" },
        { src: Frame3, alt: "pte-score-3" },
        { src: Frame4, alt: "pte-score-4" },
        { src: Frame5, alt: "pte-score-5" },
        { src: Frame6, alt: "pte-score-6" },
        { src: Frame7, alt: "pte-score-7" },
        { src: Frame8, alt: "pte-score-8" },
        { src: Frame9, alt: "pte-score-9" },
        { src: Frame10, alt: "pte-score-10" },
        { src: Frame11, alt: "pte-score-11" },
        { src: Frame12, alt: "pte-score-12" },
        { src: Frame13, alt: "pte-score-13" },
        { src: Frame14, alt: "pte-score-14" },
        { src: Frame15, alt: "pte-score-15" },
        { src: Frame16, alt: "pte-score-16" },
        { src: Frame17, alt: "pte-score-17" },
        { src: Frame18, alt: "pte-score-18" },
        { src: Frame19, alt: "pte-score-19" },
        { src: Frame20, alt: "pte-score-20" },
    ];

    const heroDescriptionSection = () => {
        return (
            <div className="text-center d-flex align-items-center justify-content-center flex-column">
                <p className="sub-title text-center FS16FW500 w-75">
                    If you’ve ever wondered who — or what — actually marks your PTE exam, the answer is: a powerful combination of artificial intelligence and human expert review. Unlike tests where a single
                    human examiner reads your essay or listens to your recording, the Pearson Test of English (PTE Academic) uses a hybrid approach. Advanced AI algorithms do the bulk of the scoring across all
                    four sections — Speaking, Writing, Reading, and Listening — but for critical tasks, human expert scorers review and verify the results to ensure accuracy and fairness.
                    <br />
                    <br />
                    This hybrid system is one of the biggest reasons PTE has become the preferred English test for students and migrants heading to Australia, New Zealand, the UK, and Canada. It combines the
                    consistency and speed of AI with the judgment and expertise of experienced human raters. You get results in as little as 48 hours, with the reassurance that a human has reviewed the most
                    important components of your score.
                    <br />
                    <br />
                    But how exactly does it work? And more importantly, how can you prepare knowing that both AI and humans will evaluate your responses? At Language Academy, we’ve built our entire PTE
                    practice platform around this understanding. Our AI-scored mock tests mirror the exact scoring logic used in the real PTE exam, so when you practise with us, you’re training yourself to
                    perform exactly the way the AI and human scorers expect.
                </p>
                <br />
                <br />
                <span
                    className="itelic plus-sans fw-700 FS16FW500"
                    style={{ color: "#182A4F", fontSize: "italic" }}
                >
                    Ready to see how you’d score on the real PTE? Try an AI-scored mock test today.
                </span>
            </div>
        );
    };
    const PteCibScore = () => {
        return (
            <div className="text-center mb-5 d-flex align-items-center justify-content-center flex-column">
                <h3 className="FS48 fw-500 top-section-text text-center">
                    How <span className="fw-600 text-success">PTE AI and Human Experts</span><br />
                    Evaluate Each Section
                </h3>
                <p className="sub-title text-center FS16FW500 w-75">
                    The PTE exam contains 65-75 questions across 22 different question types, covering four core skills — Speaking, Writing, Reading, and Listening. AI
                    evaluates each response, and human experts review certain tasks to ensure Content accuracy before final scores are confirmed. Understanding this
                    hybrid approach gives you a genuine advantage in preparation.
                </p>
            </div>
        );
    };
    const openPopup = () => {
        const modal = new window.bootstrap.Modal(
            document.getElementById("staticBackdrop")
        );
        modal.show();
    };

    const faqQuestions = [
        {
            question: "Does PTE use AI for scoring?",
            answer:
                "PTE Academic uses a combination of advanced AI and human expert review for scoring. AI handles the initial scoring across all sections, but human experts review Content on key Speaking tasks (Read Aloud, Repeat Sentence, Describe Image, Retell Lecture, Respond to a Situation, Summarize Group Discussion) and key Writing traits (Content, Development/Structure/Coherence, General Linguistic Range) before final scores are confirmed. If there’s disagreement between AI and human scoring, a second human expert makes the final judgment. This hybrid approach ensures both consistency and fairness.",
        },
        {
            question: "How accurate is PTE AI scoring?",
            answer:
                "Pearson’s AI scoring system has been validated through extensive research with data from over 10,000 test takers across 38 cities, 21 countries, and 126 first languages. The system is designed to match or exceed the reliability of human examiners alone. For Speaking, it uses Pearson’s Versant technology (a speech processing system trained on diverse linguistic backgrounds). For Writing, it uses the Intelligent Essay Assessor (IEA) powered by the Knowledge Analysis Technologies (KAT) engine using Latent Semantic Analysis (LSA). Combined with human expert review on Content, this hybrid model is highly accurate. For mock test platforms, accuracy depends on how closely the scoring engine mirrors the real PTE algorithms — Language Academy’s AI scoring is calibrated to deliver results that closely reflect your real exam performance.",
        },
        {
            question: "Is PTE scored by humans or AI?",
            answer:
                "Both. PTE uses AI for the initial scoring of all responses, but human expert scorers are involved in the process. Specifically, human experts review Content on Speaking tasks (Read Aloud, Repeat Sentence, Describe Image, Retell Lecture, Respond to a Situation, and Summarize Group Discussion) and review Content, Development/Structure/Coherence, and General Linguistic Range on the Write Essay task. For other traits like Pronunciation, Oral Fluency, Form, Grammar, Vocabulary, and Spelling, AI scoring is final. If AI and human scores disagree on Content, a second human expert provides the final judgment. This hybrid system is a key difference between PTE and tests like IELTS where only humans score Speaking and Writing.",
        },
        {
            question: "Can AI predict my PTE score in mock tests?",
            answer:
                "A well-designed AI-scored mock test can give you a strong indication of your likely real PTE score. At Language Academy, our AI scoring engine uses algorithms calibrated to the official PTE scoring system, so your mock test results serve as a reliable predictor. We recommend taking 2–3 mock tests to get a consistent baseline before booking your real exam. The more mock tests you take, the more predictive your average score becomes.",
        },
        {
            question: "How does AI evaluate pronunciation in PTE?",
            answer:
                "Pronunciation in PTE is scored by AI using Pearson’s Versant technology, a speech processing system designed specifically to evaluate English pronunciation from non-native speakers. The AI analyses vowel and consonant sound accuracy, word stress patterns, and sentence-level intonation. It compares your speech against models trained on over 10,000 test takers from diverse linguistic backgrounds. Importantly, it assesses intelligibility — whether you can be clearly understood — rather than whether you sound like a native speaker. Having an accent is perfectly fine as long as your pronunciation is clear and comprehensible. Pronunciation scoring is AI-only; it does not include human review.",
        }
    ];

    const contentSection = () => {
        return (
            <h3 className="top-section-text FS40FW600">
                Features of Our<span className="text-success FS40FW600"> AI PTE Practice Platform</span>
            </h3>
        )
    }

    const examCardData = [
        {
            icon: Work,
            title: "Full-Length Scored Mock Tests",
            content: `<div>Complete mock tests that simulate every section of PTE Academic — Speaking, Writing, Reading, and Listening — with AI scoring that matches the real exam engine. Each mock test takes a maximum of 2 hours 15 minutes, just like the real PTE, so you build the stamina and time-management skills you need for test day.</div>`
        },
        {
            icon: Growth,
            title: "Section-Wise Practice",
            content: `<div>Don’t have time for a full mock test? No problem. Practise individual sections or even specific question types. If Re-order Paragraphs is your weakness, drill that task type until it becomes your strength. Our platform lets you focus your energy where it matters most.</div>`
        },
        {
            icon: Collab,
            title: "AI-Powered Speaking Analysis",
            content: `<div>Our Speaking practice gives you instant feedback on pronunciation, oral fluency, and content. The AI highlights exactly which words you mispronounced, where your fluency dropped, and whether you captured the key content — so you know precisely what to fix in your next attempt.</div>`
        },
        {
            icon: Globe,
            title: "Writing Feedback with Scoring Breakdown",
            content: `<div>Submit essays and summaries and receive detailed scores for content, form, grammar, vocabulary, and spelling. The AI doesn’t just tell you your score — it shows you why you got that score, with specific feedback on what to improve.</div>`
        },
        {
            icon: Idea,
            title: "Realistic Timed Environment",
            content: `<div>One of the biggest challenges in PTE is time pressure. Our platform replicates the exact timing conditions of the real exam, including the auto-advance feature for Speaking tasks. Practising under real time constraints means you won’t be caught off guard on test day.</div>`
        },
        {
            icon: WorkBalance,
            title: "Performance Analytics Dashboard",
            content: `<div>Track your progress across mock tests with visual score trends, section comparisons, and personalised recommendations. See at a glance whether your Listening is improving, whether your Writing grammar score is climbing, and where you should focus your next study session.</div>`
        }
    ]

    const contentSection2 = () => {
        return (
            <h3 className="top-section-text FS40FW600">
                Accuracy of{" "}
                <span className="text-success FS40FW600">
                    AI Scoring
                    <br />
                    in Mock Tests
                </span>
            </h3>
        );
    };

    const laPreprationWorkTitle = () => {
        return (
            <h3 className="top-section-text FS40FW600">
                What Makes{" "}
                <span className="text-success FS40FW600"> Our Mock Tests </span>
                Different
            </h3>
        );
    };

    const calculatorArray = [
        {
            icon: flexibleIcon,
            title: "Real-time AI feedback",
            content: `
                    <div class='text-start'>Don’t wait hours for your results. Our platform scores your Speaking and Writing responses instantly, so you can review, learn, and re-attempt straight away.</div>
                  `,
        },
        {
            icon: TestEnvironmentIcon,
            title: "Detailed score breakdowns",
            content: `
                    <div class='text-start'>See your scores for content, pronunciation, oral fluency, grammar, vocabulary, and spelling — not just a single number. Understanding which sub-skill is dragging your score down is the fastest way to improve.</div>
                  `,
        },
        {
            icon: checkList,
            title: "Exam-identical format",
            content: `
                    <div class='text-start'>Our mock tests follow the exact PTE Academic format, including the same 65-75 question range, 22 question types, time limits, and task structure. You’ll feel like you’ve already taken the test before you walk into the test centre.</div>
                  `,
        },
        {
            icon: Filter,
            title: "Progress tracking",
            content: `
                    <div class='text-start'>Take multiple mock tests over time and watch your scores improve. Our dashboard shows your score trends across all sections so you can see what’s working.</div>
                  `,
        },
    ];
    const skillAreaTitle = () => {
        return (
            <h3 className="top-section-text FS56FW500 mb-4 white">
                Why <span className="text-success">AI + Human Review</span> Makes
                PTE More Reliable
            </h3>
        );
    };
    const lifestyleCards = [
        {
            title: "AI Provides Consistency, Humans Provide Judgment",
            text: "AI doesn’t suffer from fatigue or mood swings. Every response is evaluated against the same objective criteria every single time. But AI can sometimes misinterpret unusual or borderline responses. That’s where human experts step in. They review Content on key Speaking and Writing tasks, catching edge cases the algorithm might score unfairly and making a final judgment when AI and human scores disagree.",
            color: "rgba(255, 255, 255, 0)",
            img: Commuters,
            hoverColor: "#FFCC00",
        },
        {
            title: "Trained on Global Data",
            text: " Pearson’s AI was trained on responses from over 10,000 test takers across 38 cities in 21 countries, with speakers of 158 different countries of origin and 126 first languages. The system was built to understand and fairly evaluate non-native speakers from all backgrounds. It doesn’t penalise you for having an accent; it evaluates intelligibility.",
            color: "rgba(255, 255, 255, 0)",
            img: Professional,
            hoverColor: "#FF2D55",
        },
        {
            title: "Speed Without Sacrificing Accuracy",
            text: "PTE results are typically available within a maximum of 2 hours 15 minutes of the test itself (the test is up to 2 hours 15 minutes long), sometimes even faster. This speed is possible because AI does the initial scoring, while human experts review critical components in parallel. Compare that to IELTS, where human examiners may take 13 days to return results. The AI + human hybrid model delivers both speed and accuracy.",
            color: "rgba(255, 255, 255, 0)",
            img: Essential,
            hoverColor: "#34C759",
        },
        {
            title: "Transparency in Scoring",
            text: "On Content-scored tasks, if there’s disagreement between the AI score and the human expert review, a second human rater makes the final judgment. This three-step process (AI, human, and dispute resolution) ensures fair scoring on the most subjective elements of the test.",
            color: "rgba(255, 255, 255, 0)",
            img: Complement,
            hoverColor: "#007AFF",
        },
    ];

    const bottomStatsText = [
        { value: "50,000", highlight: "+", label: "Successful Students" },
        { value: "95", highlight: "%", label: "AI Scoring Accuracy" },
        { value: "29,000", highlight: "+", label: "Practiced Questions" },
    ]
    return (
        <React.Fragment>
            <Helmet>
                <title>AI Scoring for PTE Preparation | Instant Mock Test Evaluation</title>
                <meta
                    name="description"
                    content="Get accurate AI scoring for PTE mock tests with instant feedback, score prediction, speaking analysis & personalised improvement tips to boost your performance."
                />
                <meta name="robots" content="index, follow" />
                <link
                    rel="canonical"
                    href="https://www.languageacademy.com.au/pte-ai-scoring"
                />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@languageacademy" />
                <meta
                    name="twitter:title"
                    content="AI Scoring for PTE Preparation | Instant Mock Test Evaluation"
                />
                <meta
                    name="twitter:description"
                    content="Get accurate AI scoring for PTE mock tests with instant feedback, score prediction, speaking analysis & personalised improvement tips to boost your performance."
                />
                <meta
                    name="twitter:image"
                    content="https://www.languageacademy.com.au/images/logol.png"
                />
                <meta name="twitter:image:alt" content="LA Language Academy Logo" />
                <meta
                    property="og:url"
                    content="https://www.languageacademy.com.au/pte-ai-scoring"
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="AI Scoring for PTE Preparation | Instant Mock Test Evaluation"
                />
                <meta
                    property="og:description"
                    content="Get accurate AI scoring for PTE mock tests with instant feedback, score prediction, speaking analysis & personalised improvement tips to boost your performance."
                />
                <meta
                    property="og:image"
                    content="https://www.languageacademy.com.au/images/logol.png"
                />
                <meta property="og:image:alt" content="LA Language Academy Logo" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
            </Helmet>
            <Header />

            <section className="new-design">
                <NocBanner
                    data={heroData}
                    extraClass={"contact-hero-section pte-scoring"}
                    extraClass2={"align-items-start"}
                />
                <div className="fame-wall off-white">
                    <ReusableHomePageSlider images={images} />
                </div>
                <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
                    {heroDescriptionSection()}
                    <ButtonComp
                        // link={() => {
                        // const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
                        // modal.show();
                        // }}
                        btnText={"Join Now"}
                    />
                </div>
                <div className="custom-container py-4">
                    {PteCibScore()}
                    <ScoreInfoCard
                        bgColor="#EBF5FF"
                        icon="/images/web-new-images/icons/blue-speaking.svg"
                        title="Speaking — AI + Human Review on Key Tasks"
                        subtitle="Pronunciation and fluency  by AI, content reviewed by humans."
                        color="#0286FF"
                        features={[
                            {
                                title: "Read Aloud",
                                desc: "6-7 questions. You read a text aloud. AI scores Content (accuracy of words read), Pronunciation, and Oral Fluency. Human experts review Content.",
                            },
                            {
                                title: "Repeat Sentence",
                                desc: "10-12 questions. You listen and repeat. AI scores Content (accuracy of repetition), Pronunciation, and Oral Fluency. Human experts review Content.",
                            },
                            {
                                title: "Describe Image",
                                desc: "5-6 questions. You describe a graph, chart, or photo. Traits scored: Content (0-6), Pronunciation, and Oral Fluency. Human experts review Content.",
                            },
                            {
                                title: "Retell Lecture",
                                desc: "2-3 questions. You listen to a short lecture and summarise it. AI and human experts review Content. AI scores Pronunciation and Oral Fluency.",
                            },
                            {
                                title: "Respond to a Situation",
                                desc: "2-3 questions. You listen to a scenario and respond. Human experts review Content. AI scores Pronunciation and Oral Fluency.",
                            },
                            {
                                title: "Summarize Group Discussion",
                                desc: "2-3 questions. You listen to a discussion and write a summary. Human experts review Content. AI scores Pronunciation and Oral Fluency.",
                            },
                            {
                                title: "Answer Short Question",
                                desc: "5-6 questions. You answer listening comprehension questions. This is a Listening task (not Speaking). AI scores based on Vocabulary only.",
                            }
                        ]}
                        insight={{
                            title: "Language Academy Tip",
                            description:
                                "The key insight: Pronunciation and Oral Fluency are scored by AI alone, but Content on core Speaking tasks goes to human experts for quality assurance. This is actually a strength — it means humans catch nuances the machine might miss.",
                        }}
                        sectionText="You’re speaking into a microphone, and the PTE AI scores your response in real time. Here’s the reassuring part: the AI doesn’t care about your accent. Whether you speak with an Indian, Chinese, Vietnamese, or Latin American accent, Pearson’s AI is trained on speech from over 10,000 test takers across 38 cities, 21 countries, 158 countries of origin, and 126 first languages. It’s designed to understand and fairly score a broad spectrum of global English accents."
                        sectionSubText="For most Speaking tasks, the AI handles both pronunciation and oral fluency scoring automatically. However, content on certain tasks receives human expert review before your final score is locked in. The tasks that include human Content review are:"
                    />
                    <ScoreInfoCard
                        bgColor="#EEF7EB"
                        icon="/images/web-new-images/icons/green-writing.svg"
                        title="Writing — AI + Human Review for Critical Traits"
                        subtitle="Automated scoring with human verification on content"
                        color="#2E9E06"
                        features={[
                            {
                                title: "Content",
                                desc: "Does your response address the topic? AI scores this, and human experts review Content for both task types to ensure accuracy.",
                            },
                            {
                                title: "Form",
                                desc: "Did you follow the format rules? Summarise Written Text must be exactly one sentence, 5–75 words. Write Essay should be 200–300 words (2 points), 120–199 or 301–380 words (1 point), or outside these ranges (0 points). The AI checks this automatically with no flexibility.",
                            },
                            {
                                title: "Grammer",
                                desc: "AI analyses sentence structure, subject-verb agreement, tense consistency, and correct use of articles and prepositions. Accurate, clear grammar beats ambitious grammar riddled with errors.",
                            },
                            {
                                title: "Vocabulary",
                                desc: "AI evaluates word choice range and appropriateness. Using topic-relevant vocabulary naturally is better than forcing in unfamiliar words that don’t fit the context.",
                            },
                            {
                                title: "Spelling",
                                desc: "Every spelling error is counted. AI accepts both British and American English, but you should be consistent throughout the test.",
                            },
                            {
                                title: "Development/Structure/Coherence (Essay Only)",
                                desc: "AI and human experts review how well you organised and developed your argument. This trait is scored 0-6.",
                            },
                            {
                                title: "General Linguistic Range (Essay Only)",
                                desc: "AI and human experts evaluate the variety and sophistication of your language. This trait is scored 0-6.",
                            }
                        ]}
                        sectionText="PTE Writing tasks are Summarise Written Text and Write Essay. AI scores automatically, but for certain traits, human experts provide a final check on Content and structural elements to ensure fair and accurate scoring."
                        sectionSubText="Writing traits and how they’re evaluated:"
                    />
                    <ScoreInfoCard
                        bgColor="#FFF9EE"
                        icon="/images/web-new-images/icons/yellow-reading.svg"
                        title="Reading — Pure Comprehension, No Human Review Needed"
                        subtitle="Objective AI Scoring based on correct answers"
                        color="#FFB02C"
                        features={[
                            {
                                title: "Multiple Choice (Single Answer)",
                                desc: "You either get it right or wrong. No partial credit.",
                            },
                            {
                                title: "Multiple Choice (Multiple Answers)",
                                desc: "You earn a point for each correct choice, but lose a point for each incorrect one. Guessing randomly can lower your score.",
                            },
                            {
                                title: "Re-order Paragraphs",
                                desc: "AI scores based on correct adjacent pairs. Get some pairs right and you’ll receive partial credit.",
                            },
                            {
                                title: "Fill in the Blanks",
                                desc: "Each correct blank earns one point. No negative marking.",
                            }
                        ]}
                        sectionText="Reading tasks in PTE (Multiple Choice, Re-order Paragraphs, Fill in the Blanks) are scored based on whether your answers match the correct key. The AI compares your selections instantly. There’s no human review for Reading tasks because the scoring is entirely objective — you either selected the correct answer or you didn’t."
                        sectionSubText="Here’s how scoring works for each Reading question type:"
                    />
                    <ScoreInfoCard
                        bgColor="#F5F1FC"
                        icon="/images/web-new-images/icons/purple-listening.svg"
                        title="Listening — AI Scoring with High Accuracy"
                        subtitle="Comprehensive and accuracy combined"
                        color="#7F56D9"
                        sectionText="Listening tasks combine comprehension and accuracy. Write from Dictation is the most heavily weighted Listening task. The AI checks if you wrote the exact words you heard; every correctly spelled word earns a point. This is one of the fastest ways to gain (or lose) marks on PTE."
                        sectionSubText="For Summarise Spoken Text, AI evaluates your response using the same Content, Form, Grammar, Vocabulary, and Spelling criteria as Writing tasks. It’s a hybrid task — your listening comprehension is tested through your writing ability."
                    />
                </div>
                <SkillAreas
                    skillAreaTitle={skillAreaTitle}
                    skillSubtitle="<span>You might be wondering: doesn’t AI bias exist just like human bias? The answer is nuanced. This hybrid approach actually delivers the best of both worlds.</span>"
                    lifestyleCards={lifestyleCards}
                    MiddleInfoSection={[
                        "<p class='fw-300 FS16FW500 plus-sans text-center'>I was worried my accent would hurt my Speaking score. After practising with Language Academy’s AI mock tests, I scored 84 in Speaking and knew exactly what the AI was scoring.<br/><br/> <span class='fw-700 FS22'> Priya, PTE 79+</span></p>",
                    ]}
                    barWidth="w-100"
                //  className={"text-center d-flex flex-column align-items-center justify-content-center"}
                //  skillBottomtitle={"Your schedule doesn't have to limit your success."}
                />
                <div className="custom-container py-5">
                    <ContentImageSection
                        contentSection={contentSection2}
                        quoteText={
                            "You now understand how PTE’s AI and human experts score the real exam. But how do you use that knowledge to prepare effectively?"
                        }
                        btnLink="/contact"
                        btnText="Contact Us to Start Your Preparation"
                        btnClassName="mt-4"
                        image={Immigration}
                        imageClassName="immigration-test-img"
                        reverse={true}
                        paragraphs={[
                            "The answer is: practise with AI-scored mock tests that use the same scoring logic as the real exam. Not all mock tests are equal. Some platforms use simplified scoring that only tells you “correct” or “incorrect” — that’s not enough. To genuinely prepare for PTE, you need a practice platform that scores your Speaking pronunciation and oral fluency the way Pearson’s AI does, evaluates your essay grammar and vocabulary with the same granularity, and gives you section-by-section breakdowns so you can see exactly where to improve.",
                            "At Language Academy, our AI scoring engine is calibrated to reflect the real PTE scoring system. When you complete a mock test with us, your scores closely mirror what you’d receive on test day. This means no nasty surprises when you sit the real exam — you’ll already know where you stand.",
                        ]}
                    />
                </div>
                <div className="custom-container py-5 text-center">
                    {laPreprationWorkTitle()}
                    <div className="row">
                        {calculatorArray.map((card, index) => (
                            <div key={index} className="col-12 col-md-6 mb-4">
                                <SkillCard card={card} />
                            </div>
                        ))}
                    </div>
                    <div className="text-center">
                        <p
                            className="FS16FW500 fw-700 plus-sans mb-5"
                            style={{ color: "#182A4F", fontStyle: "italic" }}
                        >
                            See exactly how the AI scores you — take a full-length mock test now.
                        </p>
                        <ButtonComp
                            btnText={"Start Free Mock Test"}
                            link={"/auth/register"}
                        />
                    </div>
                </div>
                <ExamSkillsSection
                    contentSection={contentSection}
                    subtitle="Training In Parramatta"
                    cards={examCardData}
                    description={"Language Academy’s PTE practice platform is built for one purpose: to help you reach your target score as efficiently as possible. Here’s what you get when you sign up."}
                />
                <div className="custom-container">
                    <div className={`stats-bar stats-text-content mb-0 p-3 p-sm-3 p-md-4 d-flex flex-column flex-lg-row flex-wrap justify-content-around gap-3 custom-container`} style={{ border: "1px solid #0000000D", borderRadius: "24px" }}>
                        {bottomStatsText.map((item, i) => (
                            <StatsItemText key={i} index={i} {...item} />
                        ))}
                    </div>
                </div>
                <div style={{ padding: "40px 0 30px 0" }}>
                    <CtaBanner
                        title="Ready to Test Your"
                        highlight="Level?"
                        buttonText="Book Free Consultation"
                        onClick={openPopup}
                        rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
                        btnText="Take Free Mock Test Now"
                        subTitle={
                            "Take a free mock test and understand your current standing before enrolling. "
                        }
                    />
                </div>
                <FaqSection questions={faqQuestions} />
                <Footer />
            </section>
        </React.Fragment>
    );
});

const SkillCard = ({ card }) => {
    return (
        <div className="skill-card h-100 p-4">
            {/* Icon + Title */}
            <div className="d-flex flex-column align-items-start gap-4 mb-3">
                <div className="me-3 col-auto">
                    <img src={card.icon} alt={card.title || ""} />
                </div>
                <h6 className="text-start mb-0 plus-sans FS24FW500 fw-700 to-unset-transform col-11">
                    {card.title}
                </h6>
            </div>

            {/* Content */}
            <div className="quote-para FS16FW500" style={{ lineHeight: "28px" }}>
                {typeof card.content === "string"
                    ? ReactHtmlParser(card.content)
                    : card.content}
            </div>
        </div>
    );
};
const StatsItemText = ({ value, highlight, label, index }) => (
    <div className="text-center px-1 px-sm-2 px-md-3 stats-item-responsive">
        {([1, 0].includes(index) || highlight === "+" || highlight === "%") ? (
            <div className="hero-title fw-800 FS48">
                {value}
                <span className="symbol-text-success">{highlight}</span>
            </div>
        ) : (
            <div className="hero-title fw-800 FS48">
                <span className="symbol-text-success">{highlight}</span>
                {value}
            </div>
        )}
        <div className="FS20FW500 text-gray-pricing plus-sans mt-1">{label}</div>
    </div>
);
export default AIScoreSeo;
